// src/components/ui/Badge.js
import React from "react";

const TONE_CLASS = {
  neutral: "badge--neutral",
  success: "badge--success",
  danger: "badge--danger",
  warning: "badge--warning",
};

function Badge({ tone = "neutral", dot = false, className = "", children }) {
  const classes = [
    "badge",
    TONE_CLASS[tone] || "badge--neutral",
    dot ? "badge--dot" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>{children}</span>;
}

export default Badge;
